module.exports = __webpack_public_path__ + "img/casino-micro.2b75344c.png";